<div class="w-full space-y-4">

  <!-- Page Header -->
  <div class="flex items-center justify-between pb-4 border-b border-slate-200">
    <div class="flex items-center gap-3">
      <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
        <mat-icon class="text-slate-600">list_alt</mat-icon>
      </div>
      <div>
        <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
          Transaction List
        </h2>
        <p class="text-xs text-slate-500 font-medium mt-0.5">
          View and manage transactions
        </p>
      </div>
    </div>
  </div>

  <!-- ================= FILTERS ================= -->
  <div class="bg-white rounded-lg shadow-sm border border-slate-300 px-4 py-3">
    <div class="flex flex-col md:flex-row flex-wrap items-start md:items-center gap-3 w-full">

      <!-- Transaction Type (Mandatory) -->
      <mat-form-field appearance="outline" class="w-full md:w-[120px]">
        <mat-label>Transaction Type *</mat-label>
        <mat-select [(ngModel)]="filterTransactionType" (selectionChange)="onTypeChange()">
          <mat-option *ngFor="let type of transactionTypes" [value]="type.value">
            {{ type.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Customer (Optional) -->
      <mat-form-field appearance="outline" class="w-full md:w-[180px]">
        <mat-label>Customer</mat-label>
        <mat-select [(ngModel)]="filterCustomerId">
          <mat-option [value]="null">All Customers</mat-option>
          <mat-option *ngFor="let c of customerList" [value]="c.customerId">
            {{ c.customerName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- From Date -->
      <mat-form-field appearance="outline" class="w-full md:w-[140px]">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="filterFromDate">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>

      <!-- To Date -->
      <mat-form-field appearance="outline" class="w-full md:w-[140px]">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="pickerTo" [(ngModel)]="filterToDate">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>

      <!-- Is Active (Frontend Filter) -->
      <mat-form-field appearance="outline" class="w-full md:w-[110px]">
        <mat-label>Is Active</mat-label>
        <mat-select [(ngModel)]="filterIsActive" (selectionChange)="applyFrontendFilters()">
          <mat-option value="All">All</mat-option>
          <mat-option value="Yes">Active</mat-option>
          <mat-option value="No">Inactive</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Status (Frontend Filter) -->
      <mat-form-field appearance="outline" class="w-full md:w-[140px] md:mr-4">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="filterStatus" (selectionChange)="applyFrontendFilters()">
          <mat-option value="All">All</mat-option>
          <mat-option *ngFor="let s of statusOptions" [value]="s.value">{{ s.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Buttons -->
      <div class="flex items-center justify-end gap-3 h-auto md:h-[56px] shrink-0 w-full md:w-auto md:ml-auto">
        <button (click)="lFN_ResetFilters()" class="flex-1 md:flex-none px-6 py-2.5 rounded-lg
                    text-slate-500 text-[12px] font-medium tracking-widest uppercase
                    bg-slate-100 text-slate-900
                    transition-all duration-200">
          Reset
        </button>
        <button (click)="lFN_SearchTransactions()" class="px-6 py-2 rounded-md
                 bg-gradient-to-r from-slate-900 to-black
                 text-white text-[12px] font-medium tracking-widest uppercase
                 shadow hover:from-black hover:to-slate-800
                 transition-all duration-150 whitespace-nowrap">
          Search
        </button>
      </div>

    </div>
  </div>

  <!-- ================= TABLE ================= -->
  <div class="bg-white rounded-lg shadow-sm border border-slate-300 overflow-x-auto">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">

      <!-- SRNO -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white text-xs uppercase text-center px-4 whitespace-nowrap">Sr No.</th>
        <td mat-cell *matCellDef="let row; let i = index" class="text-center text-sm px-4 whitespace-nowrap">{{ i + 1 }}
        </td>
      </ng-container>

      <!-- Parent Transaction No -->
      <ng-container matColumnDef="parentTransactionNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="bg-gray-900 text-white text-xs uppercase text-center px-4 whitespace-nowrap">Parent Transaction No</th>
        <td mat-cell *matCellDef="let row"
          class="text-sm font-medium text-slate-600 text-center px-4 whitespace-nowrap">
          {{ (row.transactionType === TransactionType.QUOTATION || row.transactionType === TransactionType.DIRECT_ORDER)
          ? '' :
          row.parentTransactionNo }}
        </td>
      </ng-container>

      <!-- Transaction No -->
      <ng-container matColumnDef="transactionNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="bg-gray-900 text-white text-xs uppercase px-4 whitespace-nowrap">Transaction No</th>
        <td mat-cell *matCellDef="let row" class="text-sm font-medium text-slate-600 px-4 whitespace-nowrap">{{
          row.transactionNo }}</td>
      </ng-container>

      <!-- Customer Name -->
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="bg-gray-900 text-white text-xs uppercase px-4 whitespace-nowrap">Customer Name</th>
        <td mat-cell *matCellDef="let row" class="text-sm px-4 whitespace-nowrap">{{ row.customerName }}</td>
      </ng-container>

      <!-- Created On -->
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="bg-gray-900 text-white text-xs uppercase px-4 whitespace-nowrap">Created On</th>
        <td mat-cell *matCellDef="let row" class="text-sm px-4 whitespace-nowrap">{{ row.transactionDate |
          date:'dd-MMM-yyyy' }}</td>
      </ng-container>

      <!-- GST Applied Column -->
      <ng-container matColumnDef="isGstTransaction">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="bg-gray-900 text-white text-xs uppercase text-center px-4 whitespace-nowrap">GST Applied</th>
        <td mat-cell *matCellDef="let row" class="text-center px-4 whitespace-nowrap">
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold tracking-widest uppercase border"
            [ngClass]="row.isGstTransaction === 'YES' 
              ? 'bg-emerald-50 text-emerald-700 border-emerald-200' 
              : 'bg-slate-50 text-slate-600 border-slate-200'">
            <span class="w-1.5 h-1.5 rounded-full"
              [ngClass]="row.isGstTransaction === 'YES' ? 'bg-emerald-500' : 'bg-slate-400'">
            </span>
            {{ row.isGstTransaction }}
          </span>
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="bg-gray-900 text-white text-xs uppercase text-center px-4 whitespace-nowrap">Status</th>
        <td mat-cell *matCellDef="let row" class="text-center px-4 whitespace-nowrap">
          <span class="inline-block px-3 py-1 rounded-full text-[10px] font-bold tracking-widest uppercase border"
            [ngClass]="{
                  'bg-emerald-100 text-emerald-800 border-emerald-300': getStatusName(row.transactionStatus) === 'Completed' || getStatusName(row.transactionStatus) === 'Paid',
                  'bg-amber-100 text-amber-800 border-amber-300': getStatusName(row.transactionStatus) === 'Pending' || getStatusName(row.transactionStatus) === 'Draft',
                  'bg-rose-100 text-rose-800 border-rose-300': getStatusName(row.transactionStatus) === 'Cancelled' || getStatusName(row.transactionStatus) === 'Failed',
                  'bg-blue-100 text-blue-800 border-blue-300': getStatusName(row.transactionStatus) !== 'Completed' && getStatusName(row.transactionStatus) !== 'Paid' && getStatusName(row.transactionStatus) !== 'Pending' && getStatusName(row.transactionStatus) !== 'Draft' && getStatusName(row.transactionStatus) !== 'Cancelled' && getStatusName(row.transactionStatus) !== 'Failed'
                }">
            {{ getStatusName(row.transactionStatus) }}
          </span>
        </td>
      </ng-container>

      <!-- Is Active -->
      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white text-xs uppercase text-center px-4 whitespace-nowrap">Is Active</th>
        <td mat-cell *matCellDef="let row" class="text-center px-4 whitespace-nowrap">
          <button (click)="lFN_ToggleActive(row)" class="w-20 text-center px-0 py-1.5 rounded-full
                         text-[10px] font-semibold tracking-widest uppercase
                         transition-all duration-200 border" [ngClass]="row.isActive === 'YES'
                    ? 'bg-emerald-200 text-emerald-900 border-emerald-600 hover:bg-emerald-300'
                    : 'bg-rose-200 text-rose-900 border-rose-600 hover:bg-rose-300'">
            {{ row.isActive === 'YES' ? 'Active' : 'Inactive' }}
          </button>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white text-xs uppercase text-center px-2 whitespace-nowrap">Actions</th>
        <td mat-cell *matCellDef="let row" class="text-center px-2 whitespace-nowrap">
          <button mat-icon-button (click)="lFN_View(row)" matTooltip="View"><mat-icon
              class="text-slate-600 text-sm">visibility</mat-icon></button>
          <button mat-icon-button (click)="lFN_Edit(row)" matTooltip="Edit"><mat-icon
              class="text-slate-600 text-sm">edit</mat-icon></button>
          <!-- Conditional Actions -->
          <button *ngIf="isQuotation()" mat-icon-button (click)="lFN_ConvertToOrder(row)" matTooltip="Convert to Order"
            [disabled]="row.isPrinting"><mat-icon class="text-slate-600 text-sm">shopping_cart</mat-icon></button>
          <button *ngIf="isOrder()" mat-icon-button (click)="lFN_ConvertToInvoice(row)" matTooltip="Convert to Invoice"
            [disabled]="row.isPrinting"><mat-icon class="text-slate-600 text-sm">receipt</mat-icon></button>
          <button *ngIf="isOrder()" mat-icon-button (click)="lFN_CancelOrder(row)" matTooltip="Cancel Order"><mat-icon
              class="text-rose-600 text-sm">cancel</mat-icon></button>
          <button *ngIf="isQuotation()" mat-icon-button (click)="lFN_PrintQuotation(row)" matTooltip="Print Quotation"
            class="relative overflow-visible" [disabled]="row.isPrinting">
            <mat-icon class="text-slate-600 text-sm">print</mat-icon>
            <span *ngIf="row.hasMetadata"
              class="absolute top-[6px] right-[6px] h-2 w-2 rounded-full bg-indigo-500 border border-white"
              matTooltip="Has Metadata"></span>
          </button>
          <button *ngIf="isInvoice()" mat-icon-button (click)="lFN_PrintInvoice(row)" matTooltip="Print Invoice"
            class="relative overflow-visible">
            <mat-icon class="text-slate-600 text-sm">print</mat-icon>
            <span *ngIf="row.hasMetadata"
              class="absolute top-[6px] right-[6px] h-2 w-2 rounded-full bg-indigo-500 border border-white"
              matTooltip="Has Metadata"></span>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>